import useTranslation from "@casino/legacy/client/hooks/i18n/useTranslation";
import internationalCallingCodes from "@casino/legacyUi/form/FormSelect/InternationalCallingCodes";
import {
  isValidPhoneNumber,
  parsePhoneNumberFromString,
} from "libphonenumber-js";

const hasExcludedCallingCode = (
  phone: string,
  excludedCountries?: string[],
) => {
  const callingCode = parsePhoneNumberFromString(phone)?.countryCallingCode;
  return (
    !!callingCode &&
    !!excludedCountries?.some(
      (country) =>
        internationalCallingCodes[country]?.code.toString() === callingCode,
    )
  );
};

const useFormPhoneNumber = (
  required: boolean,
  excludedCountries?: string[],
) => {
  const errorMessage = useTranslation("errors.INVALID_PHONE");

  const validatePhoneNumber = (phone: string) => {
    const isValidPhone =
      (isValidPhoneNumber(phone ?? "") &&
        !hasExcludedCallingCode(phone, excludedCountries)) ||
      (!required && !phone);

    return isValidPhone || errorMessage;
  };

  return { validatePhoneNumber };
};

export default useFormPhoneNumber;
